import React, { FC, ReactNode } from 'react';
import { LoginButtonLabel, LoginButtonLogo, StyledLoginButton } from './login-buttons.styles';

interface LoginButtonProps {
  label: string;
  icon: ReactNode;
  handleClick: () => void;
}

const LoginButton: FC<LoginButtonProps> = ({ handleClick, icon, label }) => {
  return (
    <StyledLoginButton onClick={handleClick}>
      <LoginButtonLogo>{icon}</LoginButtonLogo>
      <LoginButtonLabel>{label}</LoginButtonLabel>
    </StyledLoginButton>
  );
};

export default LoginButton;
